var site = site || {};

(function($) {
  site.bfeedRenderProduct = function(args) {
    if (args.data === undefined) {
      args.data = 0;
    }
    var max = typeof args.max == 'undefined' ? args.data.length : Math.min(args.data.length, args.max);
    
    // If there are no products, delete the container and return
    if (!max) {
      args.$container.closest('.formatter-beauty-feed__isotope-item').remove();
      return;
    }
    var $wrapper = $('.product-carousel', args.$container);
    if (!$wrapper.length) {
      $wrapper = args.$container.append('<div class="product-carousel"></div>').children().last();
    }
    for (var i = 0; i < max; i++) {
      var rendered = Mustache.render( args.template, args.data[i] );
      var $product = $wrapper.append(rendered).children().last();
      // Using js instead of mustache so that button text naturally defaults to
      // add_to_cart from the product translation set
      if (typeof args.data[i].buttonText != 'undefined') {
        $('.js-add-to-cart', $product).text(args.data[i].buttonText);
      }

      site.createAddButton($('.js-add-to-cart', $product));

      // Multi-colored Shades:
      if (typeof args.data[i].skus != 'undefined' && typeof args.data[i].skus.HEX_VALUE_STRING != 'undefined' && args.data[i].skus.HEX_VALUE_STRING) {
        var hexes = args.data[i].skus.HEX_VALUE_STRING.split(',');
        var containerClass = 'swatches--single';
        if (hexes.length <= 1) {
          $('.swatch__container', $product).addClass(containerClass);
          continue;
        }
        if (hexes.length == 2) {
          containerClass = 'swatches--duo';
        } else if (hexes.length == 3) {
          containerClass = 'swatches--trio';
        } else if (hexes.length == 4){
          containerClass = 'swatches--quad';
        } else if (hexes.length == 5) {
          containerClass = 'swatches--quint';
        }
        $('.swatch__container', $product).addClass(containerClass);
        for (var j = 0; j < hexes.length; j++) {
          $('.swatch__container', $product).append('<div class="swatch--' + (j + 1) + '" style="background-color: ' + hexes[j] + ';"></div>');
        }
      }
    }
  };

  function _renderAuthProdCarousels(context) {
    // This is only for authenticated users
    if ($('body').hasClass('elc-user-state-anonymous')) return;

    var productTemplate = $('.bfeed__prod-template', context).first().html();
    var data = site.beautyFeed.data;

    // Map translations with products:
    var keys = ['purchases', 'ff_products', 'vba', 'bag', 'favorites'];
    for (var i = 0; i < keys.length; i++) {
      if (typeof data[keys[i]] == 'undefined' || !data[keys[i]].length) continue;
      // console.log(data[keys[i]], keys[i]);
      for (var j = 0; j < data[keys[i]].length; j++) {
        _.defaults(data[keys[i]][j], site.bfeed.trans[keys[i]]);
      }
    }
    if (data.bag.length) {
      data.bag[0].display_options = {
        hide_add_button: 1,
        show_cart_button: 1
      };
    }
    // Combine bag + favorites and ff + vba
    var recommended = data.ff_products;
    recommended.concat(data.vba);

    // Only one of each for wishlist/bag:
    var wanted = [];
    if (data.favorites && data.favorites.length) {
      wanted.push(data.favorites[0]);
    }
    if (data.bag.length) {
      wanted.push(data.bag[0]);
    }

    // "My Products" (Past Purchases):
    site.bfeedRenderProduct({
      template: productTemplate,
      data: data.purchases,
      max: 3,
      $container: $('.beauty-feed-tout--my-products', context)
    });

    // "Products I Want" (Wishlist + Item in Bag):
    site.bfeedRenderProduct({
      template: productTemplate,
      data: wanted,
      max: 2,
      $container: $('.beauty-feed-tout--wish-products', context)
    });

    // "Recommended Products" (Foundation Finder + VBA recommended products)
    site.bfeedRenderProduct({
      template: productTemplate,
      data: recommended,
      $container: $('.beauty-feed-tout--expert-products', context)
    });

    // Hide the foundation finder touts if the user has foundation finder results:
    if (recommended.length) {
      var $ffTouts = $('.beauty-feed-tout--tool').parents('.formatter-beauty-feed__isotope-item');
      $ffTouts = $ffTouts.add($('.beauty-feed-tout--bestseller-products').parents('.formatter-beauty-feed__isotope-item'));
      $ffTouts.remove();
    }

    // Now that the product partials are rendered, init the carousels:
    $('.product-carousel', context).slick({
      dots: true,
      arrows: true,
      infinite: true,
      slidesToShow: 1,
      // autoplay: true,
      autoplaySpeed: 5000
    });
  }

  Drupal.behaviors.bfeed_formatter = {
    attach: function(context, settings) {
      "use strict";

      _.defaults(site, {bf_massrel: {}});

      // Render products:
      _renderAuthProdCarousels(context);

      site.bf_massrel = site.bf_massrel || {};
      site.bf_massrel.beauty_feed = $('.formatter-beauty-feed__content').isotope({
        // disables initial layout
        isInitLayout: false,
        // main isotope options
        itemSelector: '.formatter-beauty-feed__isotope-item',
        layoutMode: 'masonry',
        // options for masonry layout mode
        masonry: {
          columnWidth: '.formatter-beauty-feed__isotope-item'
        }
      });

      // Bind to do things once layout is completely rendered
      site.bf_massrel.beauty_feed.isotope('on', 'layoutComplete',
        function(isoInstance, laidOutItems) {
          $('.formatter-beauty-feed').removeClass('loading');
        }
      );

      // wait for all images to load
      site.bf_massrel.beauty_feed.imagesLoaded(function() {
        site.bf_massrel.beauty_feed.isotope('layout'); // runs isotope with all prior settings applied
      });

      // Popup windows link
      $('.js-social-action--pop').click(function(e) {
        e.preventDefault();
        var newwindow = window.open($(this).attr('href'), '', 'height=480,width=640');
        if(window.focus) {
          newwindow.focus();
        }
      });

      // add active header state class
      $('.page-header').addClass(Drupal.ELB.ui.dark_nav_class);

      $('.chat-cta').click(function(e) {
        var isMobile = $('body').hasClass('device-mobile');
        if (isMobile) {
          $(this).attr('href','/customer_service/livechat/prechat.tmpl?SKILL=ELMobile');
        } else {
          e.preventDefault();
          lpMTagConfig.delegate.prechatWindow();
        }
      });

      //cleanup beauty feed wishlist carousel bug
      $('.beauty-feed-tout--wish-products .slick-slider > .product_brief--beauty-feed').each(function() {
        $(this).remove();
      });

      //cleanup beauty feed my products carousel bug
      $('.beauty-feed-tout--my-products .slick-slider > .product_brief--beauty-feed').each(function() {
        $(this).remove();
      });

      //cleanup beauty feed bestseller products carousel bug
      $('.beauty-feed-tout--bestseller-products .slick-slider > .product_brief--beauty-feed').each(function() {
        $(this).remove();
      });

      //cleanup beauty feed foundation finder carousel bug
      $('.beauty-feed-tout--products .slick-slider > .product_brief--beauty-feed').each(function() {
        $(this).remove();
      });

      //fix repeating touts issue
      $('.formatter-beauty-feed__isotope-item .slick-dots').each(function() {
        $(this).nextAll().css('display','none');
      });
    } // attach:
  }; // Drupal.behaviors.bfeed_formatter
})(jQuery);
